export let blocks = {};
export let handlers = {};

export function checkForInvalidStep (step) {
    if (!blocks[step]) {
        return false;
    }

    let invalid = false;

    let focus = true;
    Object.keys(blocks[step]).forEach(block => {
        if (blocks[step][block]) {
            invalid = true;

            if (handlers[step][block]) {
                handlers[step][block](focus);
                focus = false;
            }
        }
    });

    return invalid;
}

export function checkForInvalidBlock (step, block) {
    if (!blocks[step]) {
        return false;
    }

    let invalid = false;

    if (blocks[step][block]) {
        invalid = true;

        if (handlers[step][block]) {
            handlers[step][block](true);
        }
    }

    return invalid;
}

export function regBlock (step, block, value, onInvalidCheck) {
    blocks[step] = blocks[step] || {};
    handlers[step] = handlers[step] || {};

    blocks[step][block] = value;
    handlers[step][block] = onInvalidCheck;
}

export function removeBlock (step, block) {
    delete blocks[step][block];
    delete handlers[step][block];
}

export function setBlock (step, block, value) {
    blocks[step][block] = value;
}
